import parse from "html-react-parser";
import { Accordion, Button, Card } from "react-bootstrap";

import { ACCESS_LEVELS, PERMISSION_AREAS } from "api/common/types/auth.types";
import { checkPermissions } from "utils/permissions";

const DraftResponseToLab = ({
  review,
  readOnly,
  permissions,
  ERTMember,
  setShowResponseModal,
}) => {
  const hasEarReviewUpdatePermission = checkPermissions({
    permissions,
    area: PERMISSION_AREAS.EAR_REVIEWS,
    access: ACCESS_LEVELS.UPDATE,
  });

  const hasExistingId = review?.response?.upid;

  const hasTitleOrNote = review?.response?.gist || review?.response?.note1;

  const canCreateDraftResponse =
    !readOnly && hasEarReviewUpdatePermission && ERTMember;

  return (
    <Accordion className="my-4" flush defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <h6 className="fw-bold text-dark">DRAFT RESPONSE TO LAB</h6>
        </Accordion.Header>
        {canCreateDraftResponse && (
          <Button
            id="ear-response-button"
            size="sm"
            variant="secondary"
            className="rounded-pill"
            onClick={() => setShowResponseModal(true)}
          >
            {hasExistingId ? "Update " : "+ Add "}
            Draft Response to Lab
          </Button>
        )}
        <Accordion.Body>
          {hasTitleOrNote && (
            <Card className="mb-3">
              <Card.Body>
                <Card.Title>
                  <h4>{review?.response?.gist}</h4>
                </Card.Title>
                <Card.Text style={{ whiteSpace: "pre-wrap" }}>
                  {review?.response?.note1 && parse(review?.response?.note1)}
                </Card.Text>
              </Card.Body>
            </Card>
          )}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default DraftResponseToLab;
